<template>
    <v-dialog v-model="getDialogCheckout" v-if="getBooking.slot_id" max-width="800"
              transition="dialog-bottom-transition" persistent>
        <v-card class="pa-5">
            <v-card-text class="pa-0">
                <div class="close-icon" @click="closeModalCheckout">
                    <v-icon>mdi-close</v-icon>
                </div>
                <v-row>
                    <template>
                        <v-col cols="12" md="8" class="br-gray">
                            <div class="pa-1">
                                <h4 class="pb-2">Completa la tua prenotazione</h4>

                                <v-text-field outlined label="Nome riferimento Prenotazione"
                                              placeholder="Inserire il nome del referente della prenotazione"
                                              v-model="note" dense hide-details></v-text-field>

                                <v-text-field outlined type="number" :label="$tc('price')" v-model="price" step="0.1"
                                              min="0" dense class="mt-2"></v-text-field>

                                <template v-if="getBooking.half_hour_enabled && (((getBooking.slot_before && getBooking.slot_before.active && !getBooking.slot_before.booked) || !getBooking.slot_before) || ((getBooking.slot_after && getBooking.slot_after.active && !getBooking.slot_after.booked) || !getBooking.slot_after))">
                                    <v-alert border="left" colored-border color="green accent-4" elevation="2" dense>
                                        <p class="font-weight-bold mt-0 pt-0 mb-0 pb-0">Vuoi giocare mezz'ora in più?</p>
                                    </v-alert>
                                    <template v-if="(getBooking.slot_before && getBooking.slot_before.active && !getBooking.slot_before.booked) || !getBooking.slot_before">
                                        <v-checkbox color="primary" hide-details class="mt-0 pt-0 mb-0 pb-2"
                                                    v-model="getBooking.added_30_min_before" @change="handle30min('before')"
                                        >
                                            <template v-slot:label>
                                                <div style="font-weight: bold;font-size: 13px;color: #3f51b5;">
                                                   {{getSlotWithHalfHour(getBookingOriginal.slot_id, 'before')}}
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </template>
                                    <template v-if="(getBooking.slot_after && getBooking.slot_after.active && !getBooking.slot_after.booked) || !getBooking.slot_after">
                                        <v-checkbox color="primary" hide-details class="mt-0 pt-0 mb-0 pb-2"
                                                    v-model="getBooking.added_30_min_after" @change="handle30min('after')"
                                        >
                                            <template v-slot:label>
                                                <div style="font-weight: bold;font-size: 13px;color: #3f51b5;">
                                                    {{getSlotWithHalfHour(getBookingOriginal.slot_id, 'after')}}
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </template>
                                </template>

                                <v-list dense>

                                    <v-divider inset></v-divider>

                                    <v-list-item dense>
                                        <v-list-item-icon class="d-none d-sm-block">
                                            <v-icon color="primary">
                                                mdi-clock
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title class="evidence-booking">
                                                {{ formatDate(getBooking.slot_id) }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>Data e Orario</v-list-item-subtitle>
                                        </v-list-item-content>

                                    </v-list-item>

                                    <v-divider inset></v-divider>

                                    <v-list-item>
                                        <v-list-item-icon class="d-none d-sm-block">
                                            <v-icon color="secondary">
                                                mdi-stadium-variant
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>{{ getBooking.field_info.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ getBooking.center_info.name }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-icon v-if="getBooking.center_info.company_info.phone">
                                            <a class="text-decoration-none"
                                               :href="'tel:'+getBooking.center_info.company_info.phone"
                                               title="Chiama il centro sportivo">
                                                <v-icon color="primary">
                                                    mdi-phone
                                                </v-icon>
                                            </a>
                                        </v-list-item-icon>
                                    </v-list-item>

                                    <v-divider inset></v-divider>

                                    <v-list-item>
                                        <v-list-item-icon class="d-none d-sm-block">
                                            <v-icon color="indigo">
                                                mdi-map-marker
                                            </v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                getBooking.center_info.address_complete
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>Dove si trova il campo</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-icon>
                                            <a class="link-action-center" target="_blank"
                                               :href="'https://maps.google.com/?q='+getBooking.center_info.position.coordinates[1]+','+getBooking.center_info.position.coordinates[0]"
                                               title="Indicazioni per raggiungere il centro sportivo">
                                                <v-icon color="primary">
                                                    mdi-map
                                                </v-icon>
                                            </a>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-list>
                                <v-divider></v-divider>

                                <div class="d-flex pa-2 align-items-center" v-if="getPrice(getBooking, 'online') > 0">
                                    <span class="d-flex align-items-center">Hai un promo code ?</span>
                                    <v-text-field label="Codice Promo" single-line outlined dense hide-details
                                                  class="pl-1 pr-1" style="width: 50%" v-model="promo_code"
                                                  :disabled="price_old > 0.00"/>
                                    <v-btn color="primary" class="d-flex" small :loading="loading_promo"
                                           @click="trySubmitPromoCode" :disabled="!promo_code || price_old > 0.00">
                                        APPLICA
                                    </v-btn>
                                </div>

                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="pt-5 text-center">
                                <h5>Riepilogo Costi</h5>
                                <v-chip class="ma-2" label>
                                    <span :class="(getBooking.promo || getBooking.promo_sa) ? 'price-promo':'price'">{{ getPrice(getBooking, 'total').toFixed(2) }} €</span>
                                </v-chip>
                                <div class="text-decoration-line-through" v-if="price_old > 0.00">
                                    {{ price_old.toFixed(2) }} €
                                </div>
                                <template v-if="getPrice(getBooking, 'online') == 0">
                                    <v-btn class="ma-2" outlined color="indigo" small>
                                        DA PAGARE AL CAMPO
                                    </v-btn>
                                    <template v-if="this.booking_code == null">
                                        <p>Procedi semplicemente alla conferma della prenotazione</p>
                                        <v-btn block color="secondary" class="mt-3" @click="trySubmitBooking"
                                               :loading="loading">
                                            PRENOTA ORA
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <p>Ricordati di mostrare il codice o il QR Code al Gestore del Centro al momento
                                            del pagamento</p>
                                        <v-btn block color="primary" class="mt-3">
                                            {{ this.booking_code }}
                                        </v-btn>
                                        <QrcodeVue :value="qr_url_prefix+booking_code" size="150" level="H"
                                                   class="mt-2"/>
                                    </template>

                                </template>
                                <template v-else-if="getPrice(getBooking, 'center') == 0">
                                    <v-btn class="ma-2" outlined color="indigo" small>
                                        DA PAGARE ONLINE
                                    </v-btn>
                                    <p>Paga comodamente l'importo online con PayPal o Carta di Credito</p>
                                    <v-btn block color="secondary" class="mt-3" @click="trySubmitBooking"
                                           :loading="loading">
                                        PAGA e PRENOTA ORA
                                    </v-btn>
                                </template>
                                <template v-else>
                                    <v-simple-table dense>
                                        <tbody>
                                        <tr class="text-left">
                                            <td class="text-table">Da pagare online</td>
                                            <td class="text-table">
                                                <strong>{{ getPrice(getBooking, 'online').toFixed(2) }} €</strong></td>
                                        </tr>
                                        <tr class="text-left">
                                            <td class="text-table">Da pagare al campo</td>
                                            <td class="text-table">
                                                <strong>{{ getPrice(getBooking, 'center').toFixed(2) }} €</strong></td>
                                        </tr>
                                        </tbody>
                                    </v-simple-table>
                                    <v-btn block color="secondary" class="mt-3" @click="trySubmitBooking"
                                           :loading="loading">
                                        PAGA e PRENOTA ORA
                                    </v-btn>
                                    <p>Paga comodamente l'importo online con PayPal o Carta di Credito, poi la restante
                                        parte al campo</p>
                                </template>
                            </div>
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import QrcodeVue from 'qrcode.vue'

export default {
    name: "ModalCheckout",
    data() {
        return {
            note: '',
            price: null,
            valid_form: true,
            loading: false,
            loading_promo: false,
            booking_code: null,
            promo_code: null,
            price_old: 0.00,
            qr_url_prefix: process.env.VUE_APP_ADMIN_ENDPOINT + '#/bookings/complete?code=',
            slot_original: null
        }
    },
    computed: {
        ...mapGetters({
            'getDialogCheckout': 'checkout/getDialogCheckout',
            'getBooking': 'checkout/getBooking',
            'getBookingOriginal': 'checkout/getBookingOriginal',
            'getUser': 'user/getUser',
        }),
    },
    watch: {
      getDialogCheckout(newValue, oldValue) {
        this.price = this.getPrice(this.getBooking, 'total')
      },
      price(newValue, oldValue){
        let find = this._.find(this.getBooking.prices, {sport_id: this.getBooking.sport_selected})
        find.value_ac = 0
        find.value_ce = +this.price
      }
    },
    methods: {
        ...mapMutations({
            'setLoading': 'settings/setLoading',
            'setNotification': 'settings/setNotification',
        }),
        ...mapActions({
            'setDialogCheckout': 'checkout/setDialogCheckout',
            'submitBooking': 'checkout/submitBooking',
            'submitPromoCode': 'checkout/submitPromoCode',
            'setBooking': 'checkout/setBooking',
        }),
        async closeModalCheckout() {
            await this.setDialogCheckout(false)
            this.booking_code = null
            this.promo_code = null
            this.price_old = 0.00
            this.price = 0.00
            this.note = ''
        },
        formatDate(slot_id) {
            if (!slot_id) return ''
            var split = slot_id.split(';')
            return split[0] + ' / ' + split[1] + ' / ' + split[2] + ' dalle ore ' + split[3] + ' alle ore ' + split[4]
        },
        handle30min(mode){
            let backup = JSON.parse(JSON.stringify(this.getBookingOriginal))
            let split = backup.slot_id.split(';')
            let start_time = split[3]
            let end_time = split[4]

            let new_slot = JSON.parse(JSON.stringify(this.getBooking))
            new_slot.start = start_time
            new_slot.end = end_time
            new_slot.prices = JSON.parse(JSON.stringify(backup.prices))

            let find_price_half = new_slot.half_hour_price.find((pr) => {
                return pr.sport_id === backup.sport_selected
            })

            let find_price = new_slot.prices.find((pr) => {
                return pr.sport_id === backup.sport_selected
            })

            if(find_price && find_price_half){
                let unit = _.round(+find_price_half.value / 100, 3);
                let online = _.round(+unit * (+new_slot.split_payment.online_percentage), 2);
                let center = _.round(+unit * (+new_slot.split_payment.center_percentage), 2);

                if(mode === 'before'){
                    new_slot.added_30_min_after = false
                    if(new_slot.added_30_min_before){
                        start_time = this.$moment(start_time, 'HH:mm').subtract(30, 'minutes').format('HH:mm');
                        new_slot.start = start_time
                        new_slot.end = backup.end
                        new_slot.id = start_time+';'+backup.end
                        new_slot.slot_id = split[0]+';'+split[1]+';'+split[2]+';'+start_time+';'+backup.end
                        find_price.value_ac += online
                        find_price.value_ce += center
                        new_slot.price_30_min = +find_price_half.value
                    }else {
                        new_slot.id = backup.id
                        new_slot.slot_id = backup.slot_id
                        new_slot.start = backup.start
                        new_slot.end = backup.end
                        new_slot.prices = backup.prices
                    }

                }else if(mode === 'after'){
                    new_slot.added_30_min_before = false
                    if(new_slot.added_30_min_after){
                        end_time = this.$moment(end_time, 'HH:mm').add(30, 'minutes').format('HH:mm');
                        new_slot.end = end_time
                        new_slot.start = backup.start
                        new_slot.id = start_time+';'+end_time
                        new_slot.slot_id = split[0]+';'+split[1]+';'+split[2]+';'+backup.start+';'+end_time
                        find_price.value_ac += online
                        find_price.value_ce += center
                        new_slot.price_30_min = +find_price_half.value
                    }else {
                        new_slot.id = backup.id
                        new_slot.slot_id = backup.slot_id
                        new_slot.start = backup.start
                        new_slot.end = backup.end
                        new_slot.prices = backup.prices
                    }
                }

                this.setBooking(new_slot)
            }
        },
        getSlotWithHalfHour(slot_id, mode) {
            if (!slot_id) return ''
            let split = slot_id.split(';')
            let start_time = split[3]
            let end_time = split[4]
            if(mode === 'before'){
                start_time = this.$moment(start_time, 'HH:mm').subtract(30, 'minutes').format('HH:mm');
            }else if(mode === 'after'){
                end_time = this.$moment(end_time, 'HH:mm').add(30, 'minutes').format('HH:mm');
            }

            let find_price_half = this.getBooking.half_hour_price.find((pr) => {
                return pr.sport_id === this.getBooking.sport_selected
            })

            return 'Gioca dalle ore ' + start_time + ' alle ore ' + end_time + ' (+'+find_price_half.value.toFixed(2)+'€)'
        },
        getSport(sport_id) {
            var find = this._.find(this.getSettings.sports, {_id: sport_id})
            if (!find) return ''
            return find.name
        },
        getPrice(slot, type = 'online') {
            var find = this._.find(slot.prices, {sport_id: this.getBooking.sport_selected})
            if (!find) {
                return slot.slot_id
            } else {
                if (type == 'online') {
                    return find.value_ac
                } else if (type == 'center') {
                    return find.value_ce
                } else if (type == 'total') {
                    return find.value_ac + find.value_ce
                }
            }
        },
        async trySubmitPromoCode() {
            var slot = _.clone(this.getBooking)
            var center_info = this._.clone(slot.center_info)
            var field_info = this._.clone(slot.field_info)
            delete slot.center_info
            delete slot.field_info

            this.loading_promo = true
            var result = await this.submitPromoCode({code: this.promo_code, slot: slot})
            if (result.success) {

                var old_price = this._.find(this.getBooking.prices, {'sport_id': this.getBooking.sport_selected})
                this.price_old = old_price.value_ac + old_price.value_ce

                var new_slot = result.result.slot
                new_slot.center_info = center_info
                new_slot.field_info = field_info
                await this.setBooking(new_slot)

                this.$forceUpdate()

            } else {
                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: 'Promo Code non valido'
                })
            }
            this.loading_promo = false
        },
        async trySubmitBooking() {

            let startTime = new Date(`1970/01/01 ${this.getBooking.start}`);
            let endTime = new Date(`1970/01/01 ${this.getBooking.end}`);
            if(this.$moment(startTime).isAfter(endTime)){
                endTime = new Date(endTime.setDate(endTime.getDate() + 1));
            }

            let differenceValue = (endTime.getTime() - startTime.getTime()) / 1000;
            differenceValue /= 60;
            let diff_min = Math.abs(Math.round(differenceValue))

            if(diff_min < this.getBooking.field_info.rules.slot_time){
                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: 'Non è possibile prenotare lo slot con questa durata. Aggiungere mezz\'ora in più se è possibile'
                })
                return
            }

            if (!(this.price >= 0 && this.note !== '')) {
                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: 'Inserire nominativo e prezzo validi'
                })
                return
            }
            var slot = _.clone(this.getBooking)

            var find = this._.find(slot.prices, {sport_id: this.getBooking.sport_selected})
            find.value_ac = 0
            find.value_ce = +this.price

            slot.note = this.note + ' Prenotazione Manuale'
            slot.from_manual = true
            delete slot.center_info
            delete slot.field_info

            this.loading = true
            var result = await this.submitBooking(slot)
            this.loading = false

            if (result.success) {
                if (result.result.result) {
                    if (!result.result.result.payed) {

                        window.location.href = result.result.result.payment_url;

                    } else {

                        this.booking_code = result.result.result.booking.code

                        this.setNotification({
                            active: true,
                            color: 'success',
                            mode: 'multi-line',
                            text: 'Prenotazione avvenuta con successo.'
                        })

                        setTimeout(async () =>{
                          await this.closeModalCheckout()
                        }, 2000);

                        this.$emit('message', slot.slot_id)

                    }

                } else {

                    this.setNotification({
                        active: true,
                        color: 'error',
                        mode: 'multi-line',
                        text: result
                    })

                }


            } else {

                var message = ''
                if (result.message.result.message == 'Slot already booked') {
                    message = 'Slot non più disponibile'
                }

                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: message
                })


            }
        },

    },
    components: {
        QrcodeVue,
    },
}
</script>

<style scoped>
h4 {
    font-weight: 700;
    line-height: 1.2;
    font-size: 20px;
    color: #1f1b2d;
}

p {
    font-size: 12px;
    color: #1f1b2d;
    margin-bottom: 0;
}

a {
    color: #25a639;
}

.br-gray {
    border-right: 1px solid #efecf3 !important
}

.close-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
}

.price {
    color: rgb(39, 152, 99);
    font-weight: 600;
    font-size: 30px;
}

.price-promo {
    color: rgb(229, 17, 17);
    font-weight: 600;
    font-size: 30px;
}

.text-table {
    font-size: 12px !important;
}

.evidence-booking {
    text-decoration: underline;
    font-size: 18px;
}

.align-items-center {
    align-items: center !important;
}

</style>
